import script from "./DatasetReadme.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetReadme.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetReadme.vue?vue&type=style&index=0&id=eed60ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eed60ed6"]])

export default __exports__